<template>
  <div>
    <img
      @click="EBelge()"
      src="../../../../assets/images/logo/efatura.png"
      class="img-fluid"
      style="width: 75px"
    />
  </div>
</template>
<script>
export default {
  methods: {
    EBelge() {
      var gelen = this.params.data.url;
      window.open(gelen, "_blank");
    },
  },
};
</script>